
import * as React from 'react'
import {
  cloneElement
} from 'react'
import {
  sanitizeListRestProps,
  // ExportButton,
  // Filter,
  TopToolbar, useListContext,
  useNotify,
  useRefresh
} from 'react-admin'

import { Form, Input } from 'antd'

import { ApolloError } from '@apollo/client'
import gql from 'graphql-tag'
import { CreateButton } from 'shared/molecules/modal/CreateButton'

const GQL_CREATE_ACCOUNT = gql`
  mutation createAccount($name: String!) {
    createAccount(name: $name) {
      id
      name
    }
  }
`

type AccountListActionsType = {
  className?: string;
  filters?: any;
  accountId?: string;
}

export const AccountListActions: React.FC<AccountListActionsType> = (props) => {
  const {
    className,
    // exporter,
    filters,
    // maxResults,
    accountId,
    ...rest
  } = props
  const {
    // currentSort,
    resource,
    displayedFilters,
    filterValues,
    // hasCreate,
    // basePath,
    // selectedIds,
    showFilter,
    // total,
  } = useListContext()

  const notify = useNotify()
  const refresh = useRefresh()

  const onCreateSuccess = ({ createAccount: account }: { createAccount: Account }) => {
    notify(`${account.name} created successfully!`, { type: 'success' })
    refresh()
  }

  const onCreateFail = (error: ApolloError) => {
    console.log({ error })
    notify(`Error while creating account.`, { type: 'error' })
    refresh()
  }

  return (
    <TopToolbar className={className} {...sanitizeListRestProps(rest)}>
      {filters &&
        cloneElement(filters, {
          resource,
          showFilter,
          displayedFilters,
          filterValues,
          context: 'button',
        })}
      <CreateButton
        modalTitle="Create Account"
        query={GQL_CREATE_ACCOUNT}
        onSuccess={onCreateSuccess}
        onFailure={onCreateFail}
      >
        <Form.Item name="name" rules={[{ required: true, message: 'You must provide a name' }]}>
          <Input type="text" placeholder="Account Name" />
        </Form.Item>
      </CreateButton>
    </TopToolbar>
  )
}
